import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Errors, Form} from 'react-redux-form';
import {Col, Row} from 'react-bootstrap';
import LayoutContainer from '../layout/layout-container/index';
import ErrorMessages from '../login/error-messages';
import UserTitleSelector from '../common/form/user/user-title-selector';
import UserFirstNameInput from '../common/form/user/user-first-name-input';
import UserLastNameInput from '../common/form/user/user-last-name-input';
import DateOfBirthSelector from '../common/form/user/date-of-birth-selector';
import RequiredInput from '../common/form/elements/required-input';
import t from '../../data/translations';

class ViewUserDetailsForm extends Component {
  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  // eslint-disable-next-line class-methods-use-this
  render() {
    return (
      <LayoutContainer>
        <Form
          className="user-details-form"
          model="deep.personal_rewards"
        >
          <Errors className="errors" component={ErrorMessages} model="deep.personal_rewards"/>
          <Row>
            <Col lg={6}>
              <UserTitleSelector model="deep.personal_rewards.title" disabled/>

              <UserFirstNameInput readOnly/>

              <UserLastNameInput readOnly/>

              <DateOfBirthSelector disabled/>

              <RequiredInput
                label="Email address"
                model=".email"
                placeholder="email"
                readOnly
              />

              <RequiredInput
                label="Mobile number"
                model=".mobile"
                placeholder="mobile"
                readOnly
              />
            </Col>

            <Col lg={6}>
              <RequiredInput
                controlId="store_name"
                label="Store name"
                model=".store_name"
                placeholder="Store name"
                readOnly
              />
              <RequiredInput
                controlId="personal_address_1"
                label="Address line 1"
                model=".address_1"
                placeholder="Address line 1"
                readOnly
              />

              <RequiredInput
                controlId="personal_address_2"
                label="Address line 2"
                model=".address_2"
                placeholder="Address line 2"
                readOnly
              />

              <RequiredInput
                controlId="personal_address_3"
                label="Town"
                model=".town"
                placeholder="Town"
                readOnly
              />

              <RequiredInput
                controlId="personal_address_4"
                label="County"
                model=".county"
                placeholder="County"
                readOnly
              />

              <RequiredInput
                controlId="eircode"
                label={t('eircode')}
                model=".eircode"
                placeholder={t('eircode')}
                readOnly
              />

            </Col>

          </Row>
        </Form>
      </LayoutContainer>
    );
  }
}

export default connect()(ViewUserDetailsForm);



// WEBPACK FOOTER //
// ./src/components/personal-rewards/ppc-user-form.jsx